import { useState } from 'react';
import { styled, keyframes } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';

// 1️⃣ Define a quick “wave” animation
const wave = keyframes`
  0%   { transform: scale(1) rotate(0deg); }
  25%  { transform: scale(1.1) rotate(5deg); }
  50%  { transform: scale(0.9) rotate(-5deg); }
  75%  { transform: scale(1.1) rotate(5deg); }
  100% { transform: scale(1) rotate(0deg); }
`;

// 2️⃣ Style the Badge so its little bubble pulses when the count changes
const AnimatedBadge = styled(Badge)({
  '& .MuiBadge-badge': {
    animation: `${wave} 0.8s ease-in-out`,
  },
});

export function Upvote({ initialCount = 0 }) {
  const [count, setCount] = useState(initialCount);

  const handleClick = () => {
    setCount(c => c + 1);
  };

  return (
    <AnimatedBadge
    badgeContent={count}
    color="primary"
    overlap="circular"
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    sx={{
      position: 'absolute',
      top: 0,
      right: 0,
    }}
  >
  </AnimatedBadge>
  );
}
